import startCase from "lodash/startCase";

import type { IDynamicDropdownConfig } from "app/components/React/WidgetContainer/types";
import { StyledDropdownItem } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/domains-map/DomainsMap.styled";
import { allTrackers } from "app/services/track/track";

import type { ITopicDropdownItem, ITopicDropdownItemConfig } from "./types";

export const getTopicsDropdownItems = (topics: ITopicDropdownItemConfig[]): ITopicDropdownItem[] =>
    topics.map(({ name, id }) => {
        return {
            text: name,
            id,
        };
    });

export const getTopicsDropdownConfig = (
    topics: ITopicDropdownItemConfig[],
    selectedTopicId: string,
    callbackOnTopicChange: (topicId: string) => void,
    isDisabled: boolean = false,
): IDynamicDropdownConfig => {
    const handleDropdownOpen = (isOpen: boolean) => {
        if (isOpen) {
            allTrackers.dispatchTrackEvent("Drop Down", "open", "Topics");
        }
    };

    const handleTopicChange = ({ id }: { id: string }) => {
        allTrackers.dispatchTrackEvent("Drop Down", "click", `Topics/${id}`);
        callbackOnTopicChange?.(id);
    };

    const dropdownItems = getTopicsDropdownItems(topics);

    return {
        selectedId: selectedTopicId,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        DropDownItemComponent: StyledDropdownItem,
        width: "170px",
        onSelect: handleTopicChange,
        onToggle: handleDropdownOpen,
        items: dropdownItems,
        disabled: isDisabled,
    };
};

export const formatTopicToId = (id: string): string => {
    return id.toLowerCase().replace(/ /g, "_");
};

export const formatTopicFromId = (id: string): string => {
    return startCase(id.replace(/_/g, " "));
};
